import { StoriesScreen } from '../features/stories/StoriesScreen'
import { useShell } from '../app/outlet'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

/** Флаг `VITE_FEATURE_STORIES` выключен — раздела нет, адрес ведёт в «не найдено». */
export function StoriesPage() {
  const { toast } = useShell()
  return env.features.stories ? <StoriesScreen onToast={toast} /> : <NotFoundPage />
}
